export const COMPARE_SHARING_SCOPE = 'compare_sharing';

export const COMPARE_SHARING_INIT = `${COMPARE_SHARING_SCOPE}/INIT`;
export const GET_COMPARE_SHARING = `${COMPARE_SHARING_SCOPE}/GET_SHARING`;
export const ADD_COMPARE_SHARING_TAB = `${COMPARE_SHARING_SCOPE}/ADD_COMPARE_SHARING_TAB`;
